import { getCookie } from "./cookies";

export const header = () => {
  const token = getCookie("accessToken");
  const headers: Record<string, string> = {
    ...(token && { Authorization: `Bearer ${token}` }),
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  return headers;
};


export const setHeader = (accessToken: string) => {
  const headers: Record<string, string> = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  return headers;
};